import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Container,
  Header,
  Input,
  Message,
  Segment,
  Form,
  Radio
} from "semantic-ui-react";
import usePageData from "../state-manipulation/hooks/usePageData";
import { setSelectedPage } from "../state-manipulation/reducers/page-data/types";
import AxiosWrapper from "../utils/AxiosWrapper";
import useUserData from "../state-manipulation/hooks/useUserData";


export default function UploadMenu({ selectedPage, pageName }) {
  const { company } = useParams();
  const [menuFileName, setMenuFileName] = useState("");
  const [commitMessage, setCommitMessage] = useState("");
  const [uploadStatus, setUploadStatus] = useState(null);
  const [, pageDispatch] = usePageData();
  const [userData] = useUserData();
  const [category, setCategory] = useState("FOOD"); // default to "Food"
  const [loading, setLoading] = useState(false);


  const menuFileInputRef = useRef();

  const handleUpload = async () => {
    const file = menuFileInputRef.current.files[0];
    if (!file || !commitMessage) {
      setUploadStatus({ error: true, message: "Select a file and add a commit message." });
      return;
    }

    setLoading(true);
    setUploadStatus(null);

    const formData = new FormData();
    const userInfo = `${userData?.userInfo?.firstName} ${userData?.userInfo?.lastName}`;
    const company = userData?.selectedOrg?.name;

    formData.append("pdf", file);
    formData.append("newFileName", file.name);
    formData.append("commitMessage", commitMessage);
    formData.append("userInfo", userInfo);
    formData.append("company", company);
    formData.append("category", category);

    try {
      const res = await AxiosWrapper({
        method: 'POST',
        url: `${process.env.LTG_NEXT_APP_URL}/api/menu`,
        data: formData,
        isAuthRoute: true,
      });

      const data = res.data;
      console.log("🚀 ~ handleUpload ~ data:", data);

      if (data.success) {
        setUploadStatus({ success: true, message: "File uploaded to site successfully. Wait a few minutes for it to appear on the site." });
      } else {
        throw new Error(data.error || "Upload failed");
      }
    } catch (e) {
      setUploadStatus({ error: true, message: e.message });
    } finally {
      setLoading(false);
    }
  };

  const handleMenuFileChange = () => {
    const file = menuFileInputRef.current.files[0];
    if (file) {
      setMenuFileName(file.name);
      setUploadStatus(null);
    }
  };

  useEffect(() => {
    pageDispatch({
      type: setSelectedPage,
      payload: { selectedPage },
    });
  }, []);

  return (
    <div className="content-container">
      <Header as="h1">{pageName}</Header>

      <Segment>
        <Header as="h2">Upload Menu</Header>
        <p>Select a PDF file to upload to GitHub under <code>pdf/</code> folder.</p>

        <Button
          content="Choose File"
          labelPosition="left"
          icon="file"
          onClick={() => menuFileInputRef.current.click()}
        />
        <input
          ref={menuFileInputRef}
          type="file"
          hidden
          accept="application/pdf"
          onChange={handleMenuFileChange}
        />

        {menuFileName && <p><strong>Selected:</strong> {menuFileName}</p>}

        <Form style={{ marginTop: "1em" }}>
          <Form.Group inline>
            <label>Category:</label>
            <Form.Field
              control={Radio}
              label="Food"
              value="FOOD"
              checked={category === "FOOD"}
              onChange={() => setCategory("FOOD")}
            />
            <Form.Field
              control={Radio}
              label="Drink"
              value="DRINK"
              checked={category === "DRINK"}
              onChange={() => setCategory("DRINK")}
            />
          </Form.Group>
        </Form>

        <Input
          fluid
          placeholder="Enter a short description on what changed on this menu"
          value={commitMessage}
          onChange={(e) => setCommitMessage(e.target.value)}
          style={{ marginTop: "1em" }}
        />

        <Button
          primary
          content={loading ? "Uploading..." : "Upload to GitHub"}
          onClick={handleUpload}
          loading={loading}
          disabled={loading}
          style={{ marginTop: "1em" }}
        />


        {uploadStatus?.success && (
          <Message success content={uploadStatus.message} />
        )}
        {uploadStatus?.error && (
          <Message error content={uploadStatus.message} />
        )}
      </Segment>
    </div>
  );
}
